import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { useEffect, useState } from "react";
import { Icons, Colors } from "utils/Constants";
import { Icon, IconButton, Popover } from "@mui/material";
import { AdvancedColorPickerContent } from "components/AdvancedColorPicker/AdvancedColorPicker";

export default function ProjectString(
  projectStringLists,
  handleOpenNewModal,
  setModalType,
  editLists,
  setEditLists,
  handleDelete,
  handleStringSort,
  sorted,
  permission,
  handleColorUpdate
) {
  const [rows, setRows] = useState([]);
  const [colorPopover, setColorPopover] = useState({
    open: false,
    anchorEl: null,
    stringId: null,
  });
  const mongooseId = "_id";

  const handleEdit = (item) => {
    setModalType("Update");
    setEditLists({ ...editLists, projectString: item });
    handleOpenNewModal("Project String");
  };

  const handleColorClick = (event, stringId) => {
    setColorPopover({ open: true, anchorEl: event.currentTarget, stringId });
  };

  const handleColorClose = () => {
    setColorPopover({ open: false, anchorEl: null, stringId: null });
  };

  const handleColorSelect = (color, projectStringItem, shouldClose = false) => {
    if (!projectStringItem || !handleColorUpdate) return;
    handleColorUpdate(projectStringItem[mongooseId], color);
    if (shouldClose) {
      handleColorClose();
    }
  };

  useEffect(() => {
    if (projectStringLists) {
      const list = projectStringLists.map((item) => {
        const temp = {
          name: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.name}
            </MDTypography>
          ),
          color: (
            <MDBox sx={{ display: "flex", alignItems: "center" }}>
              {permission?.update ? (
                <MDBox
                  sx={{
                    width: 24,
                    height: 24,
                    backgroundColor: item?.colorCode || "green",
                    borderRadius: "4px",
                    border: "1px solid #e0e0e0",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    },
                  }}
                  onClick={(e) => handleColorClick(e, item[mongooseId])}
                />
              ) : (
                item?.colorCode && (
                  <MDBox
                    sx={{
                      width: 24,
                      height: 24,
                      backgroundColor: item.colorCode || "green",
                      borderRadius: "4px",
                      border: "1px solid #e0e0e0",
                    }}
                  />
                )
              )}
            </MDBox>
          ),
          from: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.fromLocation?.title}
            </MDTypography>
          ),
          to: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              {item?.toLocation?.title}
            </MDTypography>
          ),
          action: (
            <MDBox>
              {permission?.update && (
                <IconButton
                  color="secondary"
                  fontSize="medium"
                  onClick={() => handleEdit(item)}
                  sx={{ cursor: "pointer" }}
                  disabled={!item?.isDeletable || false}
                >
                  {Icons.EDIT}
                </IconButton>
              )}{" "}
              {permission?.delete && (
                <IconButton
                  color="secondary"
                  fontSize="medium"
                  onClick={() => handleDelete("ProjectString", item[mongooseId])}
                  disabled={!item?.isDeletable || false}
                >
                  {Icons.DELETE}
                </IconButton>
              )}
            </MDBox>
          ),
        };
        return temp;
      });
      setRows([...list]);
    }
  }, [projectStringLists, permission]);

  const currentProjectString =
    projectStringLists?.find((item) => item[mongooseId] === colorPopover.stringId) || null;

  const ColorPopoverComponent = (
    <Popover
      open={colorPopover.open}
      anchorEl={colorPopover.anchorEl}
      onClose={handleColorClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          backgroundColor: Colors.WHITE,
          boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
          borderRadius: "8px",
          overflow: "visible",
          zIndex: 1500,
        },
      }}
    >
      <AdvancedColorPickerContent
        colors={Colors.SCOPE_COLORS}
        selectedColor={currentProjectString?.colorCode}
        onSelect={(color) => handleColorSelect(color, currentProjectString, false)}
        onGridSelect={(color) => handleColorSelect(color, currentProjectString, true)}
        size={24}
      />
    </Popover>
  );

  return {
    ProjectStringColumns: [
      {
        Header: () => (
          <div
            onClick={handleStringSort}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleStringSort()}
            style={{ cursor: "pointer" }}
          >
            Name
            <MDBox
              position="absolute"
              top={-3}
              left="20%"
              color={sorted === "asc" ? "text" : "secondary"}
              opacity={sorted === "asc" ? 1 : 0.5}
            >
              <Icon fontSize="medium">arrow_drop_up</Icon>
            </MDBox>
            <MDBox
              position="absolute"
              top={3}
              left="20%"
              color={sorted === "desc" ? "text" : "secondary"}
              opacity={sorted === "desc" ? 1 : 0.5}
            >
              <Icon fontSize="medium">arrow_drop_down</Icon>
            </MDBox>
          </div>
        ),
        accessor: "name",
        width: "25%",
        align: "left",
      },
      { Header: "Color", accessor: "color", width: "15%", align: "left" },
      { Header: "From", accessor: "from", width: "20%", align: "left" },
      { Header: "To", accessor: "to", width: "20%", align: "left" },
      ...(permission?.update || permission?.delete
        ? [{ Header: "Action", accessor: "action", align: "right", width: "10%" }]
        : []),
    ],
    ProjectStringRows: rows,
    ColorPopover: ColorPopoverComponent,
  };
}
